<template>
<b-col>
        <template v-if="loaded === false">
            <div class="OTloading">
                <div class="OTloader"></div>
            </div>
        </template>
        <SettingsTable v-else
            :rows="ecmGeneralSettings"
            :columns="columns"
            :customOptions="customOptions"
            @sort="sort"
            @save="save">
            <template slot="table-header">
                <h1 class="text-center OT-table-title"></h1>
            </template>
        </SettingsTable>
</b-col>
</template>

<script>

import SettingsTable from '@/ecm/components/ECMSettingsTable.vue';
import ecmSettings from '@/ecm/collections/ecmconfigs.js';
import axios from 'axios';
import { showMessage} from '../../../utils/commonECM.js';
import { sortOn } from '../../../utils/commonECM.js';


export default {
    data() {
        return {
            ecmResourceStrings: require('../../../utils/resourceECM.js'),   
            sortDir:'asc',
            configs: [],
            ecmSettings: new ecmSettings({paginated: false }),
            loaded: false,
            editAction: (row, rowNumber) => {
                this.editRule(row,rowNumber);
            },
            tabname : this.$parent.$root._router.history.current.meta.label,
            path : this.$parent.$root._router.history.current.path,
            customOptions:  [
            {
                'value': 'True', 
                'text': 'True'
            },
            {
                'value': 'False',
                'text': 'False'
            }],
            columns: [
            {
                name: 'name',
                label: 'Name',
                sortable: true,
                editable:false,
                render(row) {
                    return row.attributes.name;
                }
            },{
                name: 'value',
                label: 'Value',
                sortable: false,
                editable:true,
                render(row) {
                    return row.attributes.value;
                }
            }]
        }
    },

    props: ['group'],

    computed: {

        ecmGeneralSettings() {
            var group = this.$parent.$root._router.history.current.meta.name;
            return this.configs.filter((t) => { if(t.attributes.group === group)
                return [t.attributes.name, t.attributes.value]; 
            this.configs.sort(sortOn('name', this.sortDir));
            });
        },
    },

    methods: {
        editRule(row,rowNumber) {
            row.editAction
       },

        refresh() {
            this.loaded = true;
        },

        sort(colNumber, dir) {
            var that = this;
            that.sortDir = dir;
            that.configs.sort(sortOn('name', dir));
        },

        save(element) {
            var that = this;
            that.$snotify.info(that.ecmResourceStrings.txtStartSaving);
            const value = element.attributes.value;
            var configvalue = "";
            if(value.trim().length > 0)
            {
                configvalue = JSON.stringify(value); 
                //configvalue = configvalue.replace(/"/g, ""); 
                configvalue = configvalue.replace(/"/ , ""); 
                configvalue = configvalue.replace(/"$/,"");
            }
            
            var configstring = '{"name": "' + element.attributes.name +'", "value": "' + configvalue +'"}';
            const connString = '{"settingDetails":[' + configstring + ']}';
            axios.put('/mtm-gateway-api/v1/services/ecm/config', connString,
                 {headers: {"Content-Type": "application/json; charset=UTF-8"}})
            .then((res) => {
                that.$snotify.clear();
                that.$snotify.success(that.ecmResourceStrings.txtECMConfigSettingsSaved);
             })
            .catch((err) => {
                if(element.options && element.options.attributes)
                    element.attributes.value = element.options.attributes.value;
                that.showError(err, 'save');
            });    
        },
        
        showError(err, location)
        {            
            const sTitle=this.ecmResourceStrings.ttlEcmConfigSetting;
            this.$snotify.clear();
            if(err.response)
            {
                if(err.response.data)
                {
                    this.$snotify.error(err.response.statusText, this.ecmResourceStrings.txtError, {
                        buttons: [
                            {text: this.ecmResourceStrings.txtViewDetails, action:()=>showMessage(this.$parent, 'error', sTitle, err.response.statusText, true, err.response.data), bold: true },
                        ],
                    });
                }
                else if(err.message)
                {
                    this.$snotify.error(err.response.statusText, this.ecmResourceStrings.txtError, {
                        buttons: [
                            {text: this.ecmResourceStrings.txtViewDetails, action:()=>showMessage(this.$parent, 'error', sTitle, err.response.statusText, true, err.message), bold: true },
                        ],
                    });
                }
                else
                {
                    this.$snotify.error(err.response.statusText, this.ecmResourceStrings.txtError, {
                        buttons: [
                            {text: this.ecmResourceStrings.txtViewDetails, action:()=>showMessage(this.$parent, 'error', sTitle, err.response.statusText, false, ''), bold: true },
                        ],
                    });
                }
            }
            else
            {
                this.$snotify.error(this.ecmResourceStrings.errEcmConfigSetting);
            }
        },
    },

    components: {
        SettingsTable
    },

    mounted() {
        var breadcrumbs = [{
            name: 'settings',
            meta: { label: 'Settings' }
        },{
            name: 'otic-config',
            meta: { label: 'Configurations' }
        },{
            name: this.path,
            meta: { label: this.tabname },
        }];

        this.$store.commit('breadcrumbs', breadcrumbs);
    },

    created() {
        var that = this;
        that.ecmSettings.fetch({"Content-Type": "application/json; charset=UTF-8"})
            .then(() => {
                that.configs =  that.ecmSettings.resources;
                that.loaded = true;
            }
        )
        .catch((err) => {
            this.$snotify.clear();
            if(err.message)
            {
                this.$snotify.error(err.message, this.ecmResourceStrings.txtError);
            }
            else  if(err.response)
            {
                this.$snotify.error(err.response.data, this.ecmResourceStrings.txtError);
            }
            this.loaded = true;
        });
    }
}

</script>
